<template>
  <v-dialog v-model="visible" persistent max-width="445">
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.deleteEmployees`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        class="px-4 pt-0 pb-5"
        v-html="$t(`${namespace}.deleteEmployeesMessage`).replace('[EMPLOYEES_COUNT]', `<strong>${items.length}</strong>`)"
      />

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t(`${namespace}.cancel`) }}
        </a>

        <v-btn
          color="accent"
          :loading="isLoading"
          :disabled="isLoading"
          depressed
          round
          @click.native="deleteSelectedEmployees"
        >
          {{ $t(`${namespace}.confirm`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MultipleDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close', reload)
    },

    async deleteSelectedEmployees () {
      let message = null
      this.isLoading = true

      try {
        const count = this.items.length
        const company = this.selectedCompany ? this.selectedCompany.id : null
        await this.$apiService.employeeMultiDelete(company, this.items)

        this.close(true)
        message = {
          type: 'success',
          message: `<strong class="white--text">${count}</strong> ${this.$t(`${this.namespace}.deleteEmployeesSuccess`)}`
        }
      } catch (err) {
        message = {
          type: 'error',
          message: this.$t(`${this.namespace}.deleteEmployeesError`)
        }
        console.log('ERROR:', err)
      }

      this.showAlert(message)
      this.isLoading = false
    }
  }
}
</script>
